"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _api = require("@polkadot/api");

var _account = _interopRequireDefault(require("./modules/account"));

var _datalog = _interopRequireDefault(require("./modules/datalog"));

var _launch = _interopRequireDefault(require("./modules/launch"));

var _rws = _interopRequireDefault(require("./modules/rws"));

var _staking = _interopRequireDefault(require("./modules/staking"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

var instances = {};
var defaultConfig = {
  name: false,
  runImmediate: false,
  endpoint: "wss://kusama.rpc.robonomics.network/",
  types: {},
  rpc: {}
};

var Robonomics = /*#__PURE__*/function () {
  function Robonomics(config) {
    _classCallCheck(this, Robonomics);

    this.config = _objectSpread(_objectSpread({}, defaultConfig), config);
    this.api = null;
    this.provider = null;
    this.accountManager = null;
    this.isReady = false; // modules

    this.account = new _account["default"](this);
    this.datalog = new _datalog["default"](this);
    this.launch = new _launch["default"](this);
    this.rws = new _rws["default"](this);
    this.staking = new _staking["default"](this);
    instances[config.name || config.endpoint] = this;

    if (config.runImmediate) {
      this.init();
    }
  }

  _createClass(Robonomics, [{
    key: "createProvider",
    value: function createProvider(endpoint) {
      this.provider = new _api.WsProvider(endpoint);
    }
  }, {
    key: "createApi",
    value: function () {
      var _createApi = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(config) {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _api.ApiPromise.create(_objectSpread({
                  provider: this.provider
                }, config));

              case 2:
                this.api = _context.sent;

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function createApi(_x) {
        return _createApi.apply(this, arguments);
      }

      return createApi;
    }()
  }, {
    key: "onReady",
    value: function onReady(cb) {
      var _this = this;

      if (this.isReady) {
        cb();
      } else {
        setTimeout(function () {
          _this.onReady(cb);
        }, 100);
      }
    }
  }, {
    key: "run",
    value: function () {
      var _run = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!this.api) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt("return");

              case 2:
                this.createProvider(this.config.endpoint);
                _context2.next = 5;
                return this.createApi({
                  types: this.config.types,
                  rpc: this.config.rpc
                });

              case 5:
                this.isReady = true;

                if (this.accountManager && this.accountManager.api === null) {
                  this.accountManager.setApi(this.api);
                }

              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function run() {
        return _run.apply(this, arguments);
      }

      return run;
    }()
  }, {
    key: "setAccountManager",
    value: function setAccountManager(accountManager) {
      if (this.api) {
        accountManager.setApi(this.api);
      }

      accountManager.setRws(this.rws);
      this.accountManager = accountManager;
    }
  }, {
    key: "onBlock",
    value: function () {
      var _onBlock = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(cb) {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.api.rpc.chain.subscribeNewHeads(function (header) {
                  cb(header.number.toNumber());
                });

              case 2:
                return _context3.abrupt("return", _context3.sent);

              case 3:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function onBlock(_x2) {
        return _onBlock.apply(this, arguments);
      }

      return onBlock;
    }()
  }, {
    key: "on",
    value: function () {
      var _on = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var filter,
            cb,
            _args4 = arguments;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                filter = _args4.length > 0 && _args4[0] !== undefined ? _args4[0] : {};
                cb = _args4.length > 1 ? _args4[1] : undefined;
                _context4.next = 4;
                return this.api.query.system.events(function (events) {
                  var result = [];
                  events.forEach(function (record) {
                    var event = record.event,
                        phase = record.phase;

                    if (phase.isNull) {
                      return;
                    }

                    var index = phase.value.toNumber();

                    if (event.section !== "system" && (!filter.section || event.section === filter.section) && (!filter.method || event.method === filter.method)) {
                      result.push({
                        phase: index,
                        event: event.method,
                        success: null,
                        data: event.data
                      });
                    }

                    if (event.section === "system") {
                      result.forEach(function (item, indexResult) {
                        if (item.phase === index) {
                          if (event.method === "ExtrinsicSuccess") {
                            result[indexResult].success = true;
                          } else if (event.method === "ExtrinsicFailed") {
                            result[indexResult].success = false;
                          }
                        }
                      });
                    }
                  });

                  if (result.length) {
                    cb(result);
                  }
                });

              case 4:
                return _context4.abrupt("return", _context4.sent);

              case 5:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function on() {
        return _on.apply(this, arguments);
      }

      return on;
    }()
  }], [{
    key: "getInstance",
    value: function getInstance() {
      var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (name === null) {
        var instancesArray = Object.values(instances);

        if (instancesArray.length > 0) {
          return instancesArray[0];
        }
      }

      if (instances[name]) {
        return instances[name];
      }

      throw new Error("Instance named ".concat(name, " not found"));
    }
  }]);

  return Robonomics;
}();

exports["default"] = Robonomics;